import React from 'react';

const Section$ = () => <div style={{textIndent: '2em'}}>
    <div style={{textAlign: 'center'}}>
        <br/>
        <h1 name="0-12" className="point" id="0-12">第十三章仓储物流管理制度</h1></div>
    <div style={{textIndent: '2em'}}>
        <br/>
        <h2 name="0-12-0" className="point" id="0-12-0">一、车辆或配件入库流程</h2>
        <h3 name="0-12-0-0" className="point" id="0-12-0-0">1、车辆入库流程 </h3>
        <p>1.销售支持依据车辆《入库检查单》对车辆进行验收检查。对车辆外观、车辆基本信息、随车工具、资料、密码卡、钥匙进行核对、逐一拍照并登记入库检查表内。缺一项考核20积分。</p>
        <p>2.差异项在入库检查表备注栏标准清晰，将信息提交报索赔部门。每提交一项奖励20积分。</p>
        <p>3.车辆整齐停放指定地点，锁好，断电，钥匙交由销售支持保管。收车方与交车方双方签字验收完成。</p>
        <p>4.车辆怀远入库，输入车辆基本信息与价格。</p>
        <p>5.打印入库单交至财务。</p>
        <p>6.入库检查表、车辆钥匙、单证交由销售支持部存档。</p>
        <h2 name="0-12-1" className="point" id="0-12-1">二、车辆或配件搬运、移动、存储管理标准</h2>
        <h3 name="0-12-1-0" className="point" id="0-12-1-0">1、车辆移动、存储管理流程</h3>

        <p>1.1 定期（每周五16:00前）检查库存车辆外观及蓄电池电压。填登记表。未按期检查，每次考核50积分。</p>
        <p>1.2 长途移动：办理临牌、保险、雇有相应资质的驾驶员，违反考核200积分。</p>
        <p>1.3 厂内移动：由车间调度协调有资质的驾驶员移动，违反考核100积分。</p>
        <h3 name="0-12-1-1" className="point" id="0-12-1-1">2、配件搬运、移动管理标准</h3>

        <h3 name="0-12-1-2" className="point" id="0-12-1-2">3、配件存储管理标准</h3>

        <h3 name="0-12-1-3" className="point" id="0-12-1-3">4、卡车公司配件入库流程 </h3>

        <p>积分：由部门经理或管理公司抽查时，相关岗位未按照以上流程执行的，每次考核-50分。</p>
        <h3 name="0-12-1-4" className="point" id="0-12-1-4">5、配件公司入库流程</h3>

        <h2 name="0-12-2" className="point" id="0-12-2">三、车辆或配件出库流程及标准</h2>

        <h3 name="0-12-2-0" className="point" id="0-12-2-0">1、车辆出库流程</h3>
        <p>1.销售人员向销售支持提出车辆出库申请。</p>
        <p>2.销售支持与财务确认收款情况。</p>
        <p>3.车辆怀远出库，输入车辆基本信息与价格。</p>
        <p>4.打印出库单交至财务部。</p>
        <p>5.申请开具增值税发票/形式发票，发票与单据邮寄客户处。</p>
        <h3 name="0-12-2-1" className="point" id="0-12-2-1">2、卡车公司配件出库流程</h3>

        <p>积分：由部门经理或管理公司抽查时，相关岗位未按照以上流程执行的，每次考核-50分</p>

        <h3 name="0-12-2-2" className="point" id="0-12-2-2">3、配件公司配件出库流程</h3>


        <h2 name="0-12-3" className="point" id="0-12-3">四、不良品管理细则（残次品、积压品）</h2>
        <h3 name="0-12-3-0" className="point" id="0-12-3-0">1、目的、适用范围、责权部门</h3>
        <h4>1、制定目的</h4>
        <p>规范不良品积压品的管理流程，使之有章可循。</p>
        <h4>2、适用范围</h4>
        <p>本公司库房配件存储中产生的残次品及积压品，除另有规定外，悉依本管理细则执行。</p>
        <h4>3、权责部门</h4>
        <p>3.1 各部门主管领导以及行政监察部门。</p>
        <p>3.2 各个有存储配件的子公司以及部门配件库房。 </p>
        <h3 name="0-12-3-1" className="point" id="0-12-3-1">2、不良品的定义</h3>
        <p>1、残次品</p>
        <p>1.1 根据技师的专业意见确定库存残次零件是轻微损坏可以使用。</p>
        <p>1.2 严重损坏的残次品零件单独放置一个区域，上报部门根据公司意见进行处理。</p>
        <p>1.3 轻微损坏可以使用零件单独放置一个区域，能够使用时可以打折销售，询问客户是否接受。</p>
        <p>2、积压品</p>
        <p>2.1 三年以上（包含三年）没有销售记录的零件可确定为滞销零件，货位不变但要特殊标记。</p>
        <p>2.2 三年以上（包含三年）没有销售记录的橡胶零件可标记为滞销零件，货位不变但要特殊标记。</p>
        <p>2.3 五年以上（包含五年）没有销售记录的零件可确定为积压零件，零件单独放置一个区域，能够使用时可以打折销售。</p>
        <p>2.4 五年以上（包含五年）没有销售记录的橡胶零件可确定为轻微损坏零件，根据技师专业意见进行打折销售或上报部门根据公司意见进行处理。</p>
        <h3 name="0-12-3-2" className="point" id="0-12-3-2">3、不良品管理规定</h3>
        <p>1、残次品的种类</p>
        <p>1.1 存货因挤压、摔跌、潮湿、日晒或其他原因而成残次品。</p>
        <p>1.2 经维修师傅确认并经过检验确认此配件为故障件，无法使用的配件。</p>
        <p>1.3 由于存储不当造成的配件破损及品质下降的配件（例如 日晒、风化、淋水等）</p>
        <p>1.4 其他原因发现或产生之残次品。</p>
        <h3 name="0-12-3-3" className="point" id="0-12-3-3">4、不良品的检验流程及处理规定</h3>
        <h4>1、不良品的检验流程</h4>
        <p>1.1 判定属不良品者应提出处置方式。</p>
        <p>1.2 如库管检验无法判定，或主管不认同库管人员之判定时，应向上级领导汇报或请厂家协助检验。</p>
        <p>1.3 由厂家鉴定作最后之核定，特殊情况由总负责人核定。</p>
        <h4>2、不良品的处理规定</h4>
        <p>不良品处置规定，不良品由库管或维修技师判定后，处置方式有如下几种</p>
        <p>2.1 残次品：</p>
        <p>2.1.1 经过维修人员确认配件有故障问题并上报领导确认。</p>
        <p>2.1.2 向品牌厂家提出申诉货索赔。</p>
        <p>2.1.3 由品牌厂家经过二次确认后赔付相关零件或款项。</p>
        <p>2.1.4 如是由于使用人员造成的残次品应有使用人员赔付相关配件金额。</p>
        <p>2.1.5 如厂家无法赔付则看是否可以修复或拆解使用。</p>
        <p>2.2 积压品：</p>
        <p>2.2.1 首先确认积压配件的种类以及存放货位和年限，上报领导积压件清单确认签字。</p>
        <p>2.2.2 对积压品的存储应放置固定区域或固定货位，等待查验。</p>
        <p>2.2.3 存储积压件的区域不可存放其他配件。</p>
        <p>2.2.4 对积压件上报领导，经主管领导确认后，上报公司处理。</p>
        <p>2.2.5 沟通厂家对积压件有无解决办法，请求厂家协助对积压配件做退回处理。</p>
        <p>2.2.6 对积压配件进行折扣销售、发布销售信息进行推广。折扣力度由公司决定。</p>
        <h4>3、责任考核</h4>
        <p>3.1 未按照标准及流程执行的，考核200分/次。</p>
        <p>3.2 积分：造成残次品的，考核相关责任人造成零件不良品进货价20%，并根据比例扣除相应积分100-1000分；</p>
        <h2 name="0-12-4" className="point" id="0-12-4">五、盘点管理细则</h2>
        <h2 name="0-12-5" className="point" id="0-12-5">六、各项表格范本</h2>


    </div>
</div>;

export default Section$;